import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2TransactionsEdit } from "./edit";
import { K2TransactionsNew } from "./new";
import { K2TransactionsTable } from "./table";

export default function K2Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2TransactionsEdit />} />
      <Route index element={<K2TransactionsTable />} />
      <Route path="/new" element={<K2TransactionsNew />} />
    </Routes>
  );
}
